// components/Typography.tsx
import { Typography as MuiTypography, TypographyProps as MuiTypographyProps } from '@mui/material';

import { responsiveFontSizes } from './fontSizes';

interface CustomTypographyProps extends Omit<MuiTypographyProps, 'size'> {
  size?: keyof typeof responsiveFontSizes; // 32, 24, etc.
}

const Typography = ({ size = 16, sx, ...rest }: CustomTypographyProps) => {
  return (
    <MuiTypography
      sx={{ fontSize: responsiveFontSizes[size], ...sx }}
      {...rest}
    />
  );
};

export default Typography;
